import { RouteItem } from '@eastcoal/router/types/route'

import {
  TRANSACTION_ANNOUNCEMENT_CHANNEL_PAGE_PATH,
  TRANSACTION_ANNOUNCEMENT_CREATE_PAGE_PATH,
  TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH,
  TRANSACTION_ANNOUNCEMENT_EDIT_PAGE_PATH,
  TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH
} from './constants/path'
import {
  TRANSACTION_ANNOUNCEMENT_CHANNEL_ACTION_UUID,
  TRANSACTION_ANNOUNCEMENT_LIST_PAGE_UUID,
  TRANSACTION_ANNOUNCEMENT_LIST_ACTION_UUID
} from './constants/uuid'

export const transactionAnnouncementRoute: RouteItem = {
  title: '成交公告',
  hideChildrenInMenu: true,
  children: [
    {
      title: '公告列表',
      path: TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH,
      uuid: TRANSACTION_ANNOUNCEMENT_LIST_PAGE_UUID,
      Component: () => import('./List')
    },
    {
      title: '新增文章',
      path: TRANSACTION_ANNOUNCEMENT_CREATE_PAGE_PATH,
      uuid: TRANSACTION_ANNOUNCEMENT_LIST_ACTION_UUID,
      Component: () => import('./Create')
    },
    {
      title: '编辑文章',
      path: TRANSACTION_ANNOUNCEMENT_EDIT_PAGE_PATH,
      uuid: TRANSACTION_ANNOUNCEMENT_LIST_ACTION_UUID,
      Component: () => import('./Edit')
    },
    {
      title: '查看文章',
      path: TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH,
      uuid: TRANSACTION_ANNOUNCEMENT_LIST_ACTION_UUID,
      Component: () => import('./Detail')
    },
    {
      title: '管理频道',
      path: TRANSACTION_ANNOUNCEMENT_CHANNEL_PAGE_PATH,
      uuid: TRANSACTION_ANNOUNCEMENT_CHANNEL_ACTION_UUID,
      Component: () => import('../Channel')
    }
  ]
}
